var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-primary btn-sm btn-icon",staticStyle:{"height":"1.85rem","width":"1.85rem"},attrs:{"id":"tooltip","type":"button"}},[_c('i',{staticClass:"fa fa-sticky-note"}),_c('span',{attrs:{"id":"tooltiptext"}},[_vm._v(_vm._s(_vm.note))])])
}
var staticRenderFns = []

export { render, staticRenderFns }